/**
 * Case list item domain entity.
 * Represents summary data for a case in list views (e.g., Related Cases dropdown).
 * This is SEPARATE from CaseEntity which contains detailed case data.
 * NOTE: API returns camelCase, so entity uses camelCase property names.
 */
export class CaseListItemEntity {
  public id!: string;
  public caseNumber!: string;
  public caseTypeName!: string;
  public caseTypeCategoryName!: string;
  public requestorName!: string;
  public statusName!: string;
  public statusDisplayName!: string;
  public statusColor!: string;
  public statusCategoryName!: string;
  public priorityCode!: string;
  public primaryAssigneeName!: string | null;
  public createdOn!: string;
  public dueDate!: string | null;
  public unreadMessageCount!: number;
}
